import { InvoiceStatusDataType } from '@/types'

export const enum InvoiceStatusEnum {
    // Invoice
    UNPAID = 'Unpaid',
    PENDING = 'Pending',
    PAID = 'Paid',

    // Credit Memo
    APPLIED = 'Applied',
    UNAPPLIED = 'Unapplied'
}

export const INVOICE_STATUSES: InvoiceStatusDataType[] = [
    {
        key: InvoiceStatusEnum.UNPAID,
        title: 'Unpaid',
        color: 'error'
    },
    {
        key: InvoiceStatusEnum.PENDING,
        title: 'Pending',
        color: 'warning'
    },
    {
        key: InvoiceStatusEnum.PAID,
        title: 'Paid',
        color: 'success'
    },
    {
        key: InvoiceStatusEnum.APPLIED,
        title: 'Applied',
        color: 'primary'
    },
    {
        key: InvoiceStatusEnum.UNAPPLIED,
        title: 'Unapplied',
        color: 'purple'
    }
]

export const INVOICE_STATUS_COLOR_MAP = {
    error: {
        text: 'text-error-700',
        bg: 'bg-error-50'
    },
    warning: {
        text: 'text-warning-700',
        bg: 'bg-warning-50'
    },
    success: {
        text: 'text-success-700',
        bg: 'bg-success-50'
    },
    primary: {
        text: 'text-primary-700',
        bg: 'bg-primary-50'
    },
    purple: {
        text: 'text-purple-700',
        bg: 'bg-purple-50'
    }
}
